import { useContext } from 'react';

import { StateContext } from './State';

export function useStateContext() {
    const context = useContext(StateContext);

    if (context === undefined) {
        throw new Error('useStateContext must be used within a provider');
    }

    return context;
}
